export default class BubbleHeader {
  constructor(element) {
    this.element = element;

    this.options = {
      threshold: 0.05,
      alwaysShow: false,
    };

    this.scrollPosition = 0;
    this.lastScrollPosition = 0;
    this.html = document.documentElement;

    // Appareil tactile = pas de survol possible : le header reste toujours déployé
    this.touchQuery = window.matchMedia('(hover: none), (pointer: coarse)');

    this.init();
  }

  init() {
    this.setOptions();
    this.element.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.element.addEventListener('mouseleave', this.onMouseExit.bind(this));
    // Clavier : Tab vers un lien déploie le header, comme le survol
    this.element.addEventListener('focusin', this.onMouseEnter.bind(this));
    this.element.addEventListener('focusout', this.onMouseExit.bind(this));
    window.addEventListener('scroll', this.onScroll.bind(this));
    // Si l'appareil change de mode (ex.: tablette + souris), on s'adapte
    this.touchQuery.addEventListener('change', this.updateMode.bind(this));
    this.updateMode();
  }

  isTouchDevice() {
    return this.touchQuery.matches;
  }

  updateMode() {
    if (this.isTouchDevice()) {
      this.onMouseEnter(); // déployé en permanence
    } else {
      this.onMouseExit(); // comportement normal : se replie après inactivité
    }
  }

  setOptions() {
    this.options.threshold = this.element.dataset.threshold;
    if ('alwaysShow' in this.element.dataset) {
      this.options.alwaysShow = true;
    }
  }

  onScroll() {
    this.lastScrollPosition = this.scrollPosition;
    this.scrollPosition = document.scrollingElement.scrollTop;

    //this.setHeaderState();
    //this.setDirections();
  }

  onMouseEnter() {
    this.clearTimers();
    this.element.classList.remove('standby');
    this.element.classList.remove('inactive');
  }

  onMouseExit() {
    // Jamais de repli sur mobile, ni si data-always-show est présent
    if (this.isTouchDevice() || this.options.alwaysShow) return;

    this.clearTimers(); // évite d'empiler plusieurs minuteries
    this.timeoutStandby = setTimeout(() => {
      this.element.classList.add('standby');
    }, 6000);
    this.timeoutInactive = setTimeout(() => {
      this.element.classList.add('inactive');
    }, 1800);
  }

  clearTimers() {
    clearTimeout(this.timeoutStandby);
    clearTimeout(this.timeoutInactive);
  }

  /*setHeaderState() {
    if (!this.options.alwaysShow) {
      if (
        this.scrollPosition >
        document.scrollingElement.scrollHeight * this.options.threshold
      ) {
        this.onMouseExit();
      } else {
        this.onMouseEnter();
      }
    }
  }

  setDirections() {
    if (!this.options.alwaysShow) {
      if (this.scrollPosition >= this.lastScrollPosition) {
        //scroll vers le bas
        this.html.classList.add('is-scrolling-down');
        this.html.classList.remove('is-scrolling-up');
      } else {
        //scroll vers le haut
        this.html.classList.remove('is-scrolling-down');
        this.html.classList.add('is-scrolling-up');
      }
    }
  }*/
}
